module.exports = __webpack_public_path__ + "img/logo.64fa99e9.png";